import Vue from 'vue'
import confirm from './confirm.vue'

const ConfirmBox = Vue.extend(confirm);

let Confirm = (prize, prizeList, options) => {
  // if (typeof title === 'object') {
  //   options = title;
  //   title = '';
  // } else if (title === undefined) {
  //   title = '';
  // }

  options = Object.assign({
    prizeList: prizeList,
    prize: prize
  }, options);

  let instance = new ConfirmBox({
    data: options
  }).$mount();

  document.body.appendChild(instance.$el);

  return instance.confirm();
};

export default Confirm;
